<template>
    <svg aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        width="28"
        height="28"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#fff"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
    >
        <path d="M3 13a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z" />
        <path d="M9 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0" />
        <path d="M13 11v-4a4 4 0 1 1 8 0v4" />
    </svg>
</template>